import { createSelector } from '@reduxjs/toolkit';

export const selectOrderRoot = state => state.order;

export const selectOrder = createSelector(
  selectOrderRoot,
  order => order.orderInformation
);

export const selectOrderInformation = createSelector(
  selectOrder,
  orderInformation => orderInformation.information
);

export const orderInformationErrors = createSelector(
  selectOrderRoot,
  order => order.orderInformationErrors
);

export const selectInformationIsDisabled = createSelector(
  selectOrderRoot,
  (order) => order.orderInformationIsDisabled
);

export const selectOrderIsProcessing = createSelector(
  selectOrderRoot,
    order => order.orderIsProcessing
);

export const selectOrderErrors = createSelector(
  selectOrderRoot,
  order => order.orderErrors
);

export const selectAttachmentsDropbox = createSelector(
  selectOrder,
  (order) => order.attachments.dropbox
);

export const selectAttachmentsAmazon = createSelector(
  selectOrderRoot,
  (order) => order.orderInformationTempAmazon
);
